'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagUgAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 2.66667H28V0H0V2.66667Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 13.3333H28V10.6667H0V13.3333Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 10.6667H28V6.66667H0V10.6667Z",
          fill: "#ED1623"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 6.66667H28V2.66667H0V6.66667Z",
          fill: "#FEE044"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V17.3333H0V20Z",
          fill: "#ED1623"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 17.3333H28V13.3333H0V17.3333Z",
          fill: "#FEE044"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 14.6667C16.5773 14.6667 18.6667 12.5773 18.6667 10C18.6667 7.42267 16.5773 5.33333 14 5.33333C11.4227 5.33333 9.33333 7.42267 9.33333 10C9.33333 12.5773 11.4227 14.6667 14 14.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.9024 7.56904C12.7722 7.43886 12.7722 7.22781 12.9024 7.09763L13.3142 6.68578C13.3269 6.67306 13.3383 6.65968 13.3492 6.64535C13.3842 6.59921 13.4735 6.48654 13.5778 6.39168C13.7545 6.23097 14.2579 6.2141 14.4323 6.37733C14.4797 6.42164 14.5229 6.47098 14.5591 6.51619C14.631 6.60616 14.6353 6.7293 14.5838 6.83232L14.0352 7.92962C14.012 7.9759 14 8.02694 14 8.07869V8.46066C14 8.58691 14.0713 8.70233 14.1843 8.7588L15.285 9.30914C15.317 9.32516 15.3462 9.34625 15.3716 9.37158L16.4968 10.4968C16.5982 10.5982 16.6234 10.7532 16.5592 10.8816L16.2068 11.5863C16.1051 11.7898 15.8339 11.8339 15.673 11.673L15.569 11.569C15.4389 11.4389 15.2278 11.4389 15.0976 11.569L14.7643 11.9024C14.7018 11.9649 14.6667 12.0497 14.6667 12.1381V12.5286C14.6667 12.617 14.7018 12.7018 14.7643 12.7643C14.9743 12.9743 14.8256 13.3333 14.5286 13.3333H14.1381C13.8411 13.3333 13.6924 12.9743 13.9024 12.7643C13.9649 12.7018 14 12.617 14 12.5286V12.3333C14 12.1492 13.8508 12 13.6667 12H13.4714C13.383 12 13.2982 12.0351 13.2357 12.0976L12.9024 12.431C12.7722 12.5611 12.5611 12.5611 12.431 12.431L12.2357 12.2357C12.1055 12.1055 12.1055 11.8945 12.2357 11.7643L12.569 11.431C12.6315 11.3685 12.7163 11.3333 12.8047 11.3333H13.1953C13.4922 11.3333 13.641 10.9743 13.431 10.7643L12.2357 9.56903C12.1055 9.43886 12.1055 9.22781 12.2357 9.09763L13.0976 8.2357C13.2278 8.10553 13.2278 7.89447 13.0976 7.7643L12.9024 7.56904Z",
          fill: "#262626"
        }
      )
    ]
  }
);
const VpFlagUgAsset = forwardRef(FlagUgAsset);

export { VpFlagUgAsset as default };
